/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function GroupEditViewController (
    this: JS5Object,
    $location: JS5Object,
    GroupsService: JS5Object,
    PermissionsService: JS5Object
) {
    this.getBreadcrumbName = function () {
        return GroupsService.breadcrumbName;
    };

    this.setActiveTab = (tab: JS5Object) => {
        $location.search('view', tab);
        if (this.currentTab !== tab) {
            this.currentTab = tab;
        }
    };

    this.$onInit = () => {
        this.isAdmin = PermissionsService.isAdmin();
        this.setActiveTab($location.search().view || 'properties');
    };
}

angular.module('prism-ui.groups').component('groupEditView', {
    templateUrl: 'system/groups/editor/group-edit-view-template.html',
    controller: GroupEditViewController,
    bindings: {
    }
});
